import { RoleEnum } from "./RoleEnum";

export interface UserSession {
  userId: number;
  institutionId?: number;
  roleId: RoleEnum;
  niasMessageId: string;
  niasNavigationToken: string;
  niasSessionId: string;
  oib: string;
  name: string;
}

export default UserSession;

export const userSessionInitial: UserSession = {
  userId: 0,
  institutionId: undefined,
  roleId: RoleEnum.None,
  niasMessageId: "",
  niasNavigationToken: "",
  niasSessionId: "",
  oib: "",
  name: ""
}
